import { ISignatureOptions } from "../models/ISignatureOptions";
import { defaultOptions as mockUploadOptions, ImageView } from "../../sg-fileupload";
import { makeFailure, makeSuccess } from "../../sg-core";


export const mockSignatureOptions: ISignatureOptions = {
    uploadSignature: async (data) => {
        try {
            return makeSuccess((await mockUploadOptions.uploadFile(data)).id);
        } catch (error) {
            return makeFailure(error as Error)
        }
    },
    renderSignature: (id) => <ImageView id={id} width="500" alt="Signature" noDownloadLink />,
    renderSignatoryName: ({ name, personId }) => <span> {personId || name} </span>,

    removeSignatureConfirmationText: "Oletko varma että haluat poistaa allekirjoituksen.",
    signatureCannotBeEmptyText: "Allekirjoitus ei voi olla tyhjä",
    addNewSignatureText: "Lisää uusi allekirjoitus",
    addSignatureText: "Lisää allekirjoitus",
    clearText: "Tyhjennä",
    acceptText: "Hyväksy"

}